<template>
  <div>
    <item-info-container
      :imageURL="image"
      :originalPrice="originalPrice"
      :salePrice="salePrice"
      :hidePrice="hidePrice"
      :name="name"
    />

    <div class="p-4 text-start">
      <div v-if="description" class="mb-4 scss-text-white-space-preserved">
        {{ description }}
      </div>

      <div class="d-flex flex-row">
        <div class="d-flex flex-column scss-bold w-25">
          <span>Duration:</span>
          <span>Section:</span>
          <span>Category:</span>
        </div>

        <div class="d-flex flex-column flex-grow-1 text-end text-truncate w-75">
          <span class="text-truncate">
            {{ processingTime }}
          </span>
          <span class="text-truncate">
            {{ section ?? '-' }}</span>
          <span class="text-truncate">
            {{ category ?? '-' }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ItemInfoContainer from "@/components/ItemInfoContainer.vue";

export default {
  name: "ExpandableListItemDetail",
  components: {
    ItemInfoContainer,
  },
  computed: {
  },
  props: {
    image: String,
    processingTime: String,
    name: String,
    description: String,
    originalPrice: String,
    salePrice: String,
    section: String,
    category: String,
    promotion: Boolean,
    futurePromotion: Boolean,
    hidePrice: { // hide originalPrice and salePrice
      type: [Boolean, Number],
      default: false,
    },
  },
  methods: {
  },
};
</script>

<style lang="scss" scoped>

</style>
